import { CommonDateRange } from 'components';
import React, { useContext, useEffect, useState } from 'react'
import { BsDownload } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi';
import moment from 'moment';
import { getJournalReport, getPLR } from '_services/reportService/reportService';
import StorageService from 'utils/StorageServices/StorageServices';
import { utils } from 'helper';
import { Link } from 'react-router-dom';
import { UserContext } from 'context';

const HorizontalProfitAndLoss = () => {

    const { generalLedgerDate, setGeneralLedgerDate } = useContext(UserContext);
    const [pLRData, setPLRData] = useState({});
    const [loading, setLoading] = useState(false);
    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setGeneralLedgerDate(newRange)
    };

    useEffect(() => {
        getPLRList()
    }, [selectedRange])

    const getPLRList = async () => {
        setLoading(true)
        const payload = {
            company_id: StorageService.getCompanyId(),
            start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        }
        try {
            const res = await getPLR(payload);
            if (res?.responseCode == 200) {
                setPLRData(res?.data)
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const resetFunction = () => {
        const newStartDate = moment().startOf('month');
        const newEndDate = moment().endOf('month');

        setSelectedRange({
            startDate: newStartDate,
            endDate: newEndDate,
        });
        setGeneralLedgerDate({
            startDate: newStartDate,
            endDate: newEndDate,
        });
    };

    return (
        <>
            <div className='__znDe_mainBx'>
                <div>
                    <div className='panel-heading'>
                        <h2><span>Horizontal Profit and Loss</span></h2>

                        <div className='panel-ctrls report-control'>
                            <div>
                                <CommonDateRange
                                    key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                    initialStartDate={selectedRange.startDate}
                                    initialEndDate={selectedRange.endDate}
                                    onApply={handleApply}
                                />
                            </div>

                            <button className='__bxs_srBtn'>
                                <BsDownload />
                            </button>

                            <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                                <FiRefreshCcw />
                            </button>
                        </div>
                    </div>
                </div>

                <div className='__hrlMain_dix'>
                    <div className='voucher report-voucher report-h printable'>
                        <div className='__mainPanel'>
                            <div className="panel panel-primary">
                                <div className='panel-body '>
                                    <div className='py-20 block-ui block-ui-anim-fade'>
                                        <div className='clear-both text-center p-10'>
                                            <div class="__hrlMx_head" >
                                                <p>{pLRData?.company?.company ? pLRData?.company?.company : '-'}</p>
                                                <h4>Horizontal Profit and Loss</h4>
                                                <h5>From <span> {pLRData?.start_date ? utils.getDateByApiResponse(pLRData?.start_date) : ""} </span>  To <span> {pLRData?.end_date ? utils.getDateByApiResponse(pLRData?.end_date) : ""} </span></h5>
                                            </div>
                                        </div>

                                        <div className='clear-both'>
                                            <table>
                                                {loading ? <span className='m-5 commonCenter_avt'> Loading... </span> : <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item text-left'> Expenses </div>
                                                                    <div className='rpt-cell rpt-col-total text-end'>  {pLRData?.start_date ? utils.getDateByApiResponse(pLRData?.start_date) : ""}  </div>
                                                                </div>
                                                                {pLRData?.Expenses?.expenses?.map((expenseItem, expenseIndex) => {
                                                                    return (
                                                                        <React.Fragment key={expenseIndex}>

                                                                            <div className='highlight-row'>
                                                                                <div className='rpt-cell rpt-col-item text-left'><strong> {expenseItem?.name} </strong></div>
                                                                                <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                <div className='rpt-cell rpt-col-qty text-end'></div>
                                                                            </div>
                                                                            {expenseItem?.accounts?.map((el, ind) => {
                                                                                return (
                                                                                    <div className='subHead'>
                                                                                        <div className='highlight-row'>
                                                                                            <div className='rpt-cell rpt-col-item text-left'> &nbsp; &nbsp; {el?.name}</div>
                                                                                            <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                            <div className='rpt-cell rpt-col-qty text-end'>{el?.balance}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item text-left'> Income </div>
                                                                    <div className='rpt-cell rpt-col-total text-end'>  {pLRData?.start_date ? utils.getDateByApiResponse(pLRData?.start_date) : ""}  </div>
                                                                </div>
                                                                {pLRData?.Income?.income?.map((expenseItem, expenseIndex) => {
                                                                    return (
                                                                        <React.Fragment key={expenseIndex}>

                                                                            <div className='highlight-row'>
                                                                                <div className='rpt-cell rpt-col-item text-left'><strong> {expenseItem?.name} </strong></div>
                                                                                <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                <div className='rpt-cell rpt-col-qty text-end'></div>
                                                                            </div>
                                                                            {expenseItem?.accounts?.map((el, ind) => {
                                                                                return (
                                                                                    <div className='subHead'>
                                                                                        <div className='highlight-row'>
                                                                                            <div className='rpt-cell rpt-col-item text-left'> &nbsp; &nbsp; {el?.name}</div>
                                                                                            <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                                            <div className='rpt-cell rpt-col-qty text-end'>{el?.balance}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item text-left'><strong>Operating Expense</strong></div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'> <strong>{utils.getTotalAmount(pLRData?.Expenses?.expenses?.filter(el => el.name === 'Operating Expense'), 'balance')}</strong> </div>
                                                                    </div>
                                                                </div>

                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item text-left'><strong>Non Operating Expense</strong></div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'><strong>{utils.getTotalAmount(pLRData?.Expenses?.expenses?.filter(el => el.name === 'Non Operating Expense'), 'balance')}</strong></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item text-left'><strong>Operating Income</strong></div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'> <strong>{utils.getTotalAmount(pLRData?.Income?.income?.filter(el => el.name === 'Operating Income'), 'balance')}</strong> </div>
                                                                    </div>
                                                                </div>

                                                                <div className='subHead'>
                                                                    <div className='highlight-row'>
                                                                        <div className='rpt-cell rpt-col-item text-left'><strong>Non Operating Income</strong></div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                        <div className='rpt-cell rpt-col-qty text-end'><strong>{utils.getTotalAmount(pLRData?.Income?.income?.filter(el => el.name === 'Non Operating Income'), 'balance')}</strong></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item text-left'> &nbsp; Total Expenses </div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'> {pLRData?.Expenses?.total_expense} </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='report-table w-100 bl '>
                                                                <div className='row-total'>
                                                                    <div className='rpt-cell rpt-col-item text-left'> &nbsp; Total Income </div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'>&nbsp;</div>
                                                                    <div className='rpt-cell rpt-col-qty text-end'> {pLRData?.Income?.total_income} </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>}
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        // <div className='__hrlMain_dix'>
        //     <div className='__inr_hrlMxs'>
        //         <div>
        //             <div className='__hrlMx_head'>
        //                 <p>Eminence</p>
        //                 <h4>Horizontal Profit and Loss</h4>
        //                 <h5><span>From</span> 01/01/2025 <span>To</span> 31/01/2025</h5>
        //                 <h5><span>Basis</span> : Accrual</h5>
        //             </div>

        //             <table className='balancesheet-tformat'>
        //                 <tbody>
        //                     <tr>
        //                         <td>
        //                             <div className='__titleBl'>
        //                                 <i>Expense</i>
        //                             </div>

        //                             <div className='details-section px-4 py-0'>
        //                                 <div className='accounts-row text-uppercase'>
        //                                     Opening Stock
        //                                     <a className='float-end' href="#">0.00</a>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section px-4 py-0'>
        //                                 <div className='accounts-row text-uppercase'>
        //                                     Purchases
        //                                     <a className='float-end' href="#">0.00</a>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section px-4 py-0'>
        //                                 <div className='accounts-row text-uppercase'>
        //                                     Vendor Credits
        //                                     <a className='float-end' href="#">0.00</a>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section px-4 py-0'>
        //                                 <div className='accounts-row text-uppercase'>
        //                                     Inventory Adjustment
        //                                     <a className='float-end' href="#">0.00</a>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section '>
        //                                 <span className='text-uppercase'>
        //                                     <b>Cost of Goods Sold</b>
        //                                 </span>
        //                                 <div style={{ padding: '8px 3px' }}>
        //                                     <div className='accounts-row text-end text-uppercase apply-border'>
        //                                         Total Cost of Goods Sold &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.00
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section '>
        //                                 <span className='text-uppercase'>
        //                                     <b>Operating Expense</b>
        //                                 </span>
        //                                 <div style={{ padding: '8px 3px' }}>
        //                                     <div className='accounts-row text-end text-uppercase apply-border'>
        //                                         Total Operating Expense &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.00
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section '>
        //                                 <span className='text-uppercase'>
        //                                     <b>Non Operating Expense</b>
        //                                 </span>
        //                                 <div style={{ padding: '8px 3px' }}>
        //                                     <div className='accounts-row text-end text-uppercase apply-border'>
        //                                         Total Non Operating Expense &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.00
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section px-4 py-0'>
        //                                 <div className='accounts-row text-uppercase well zb-well'>
        //                                     Net Profit/Loss
        //                                     <span className='float-end'>0.00</span>
        //                                 </div>
        //                             </div>
        //                         </td>
        //                         <td>
        //                             <div className='__titleBl'>
        //                                 <i>Income</i>
        //                             </div>

        //                             <div className='details-section '>
        //                                 <span className='text-uppercase'>
        //                                     <b>Operating Income</b>
        //                                 </span>
        //                                 <div style={{ padding: '8px 3px' }}>
        //                                     <div className='accounts-row text-end text-uppercase apply-border'>
        //                                         Total Operating Income  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.00
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section px-4 py-0'>
        //                                 <div className='accounts-row text-uppercase'>
        //                                     Closing Stock
        //                                     <a className='float-end' href="#">0.00</a>
        //                                 </div>
        //                             </div>

        //                             <div className='details-section '>
        //                                 <span className='text-uppercase'>
        //                                     <b>Non Operating Income</b>
        //                                 </span>
        //                                 <div style={{ padding: '8px 3px' }}>
        //                                     <div className='accounts-row text-end text-uppercase apply-border'>
        //                                         Total Non Operating Income &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.00
        //                                     </div>
        //                                 </div>
        //                             </div>
        //                         </td>
        //                     </tr>

        //                     <tr>
        //                         <td>
        //                             <i>
        //                             Total
        //                             <span className='float-end'>0.00</span>
        //                             </i>
        //                         </td>
        //                         <td>
        //                             <i>
        //                             Total
        //                             <span className='float-end'>0.00</span>
        //                             </i>
        //                         </td>
        //                     </tr>
        //                 </tbody>
        //             </table>

        //             <div className='position-sticky start-0'>
        //                 <div className='px-3 mb-2 balancesheet-tformat-legend py-2' >
        //                     <small style={{fontSize: '12px'}}>**Amount is displayed in your base currency</small>
        //                     &nbsp;
        //                     <small style={{fontSize: '9.75px'}} className='badge bg-success d-inline rounded-0'>INR</small>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default HorizontalProfitAndLoss